@if (shiftId) {
  @let isShiftDraggableFeatureFlag =
    'portal-shift-timeline-shift-drag-drop' | featureFlagPure | async;
  @let isShiftSelected =
    shiftMultiSelectHelperService.selectedShifts$
      | isShiftSelected: shiftId
      | async;
  @let shiftColorOption = shiftColorOption$ | async;
  @let hasProjectReadPermission =
    can(RoleAction.Read, RolePermissionSubject.Project);
  @let isLoadingValidations =
    shiftCardTooltipStateService.isShiftValidationLoading$ | async;
  @let hasShiftBeenValidated =
    shiftCardTooltipStateService.hasShiftBeenValidated$ | async;
  @let isShiftValid = shiftCardTooltipStateService.isShiftValid$ | async;
  @let isLoadingValidationsError =
    shiftCardTooltipStateService.isLoadingValidationsError$ | async;
  @let showShiftValidation =
    !!(
      unassignedRegionCellViewShiftsDetailsRenderService.showShiftValidation$
      | async
    );
  @defer (on hover) {
    <ng-container
      *ngTemplateOutlet="
        shiftCardWrapper;
        context: {
          outletTemplate: cardDetailWithTooltip,
        }
      "
    >
    </ng-container>

    <ng-template #cardDetailWithTooltip>
      <wilson-shift-validation-tooltip-wrapper
        [showShiftValidation]="showShiftValidation"
        [plannedShiftStartDateTime]="plannedShiftStartDateTime"
        [plannedShiftEndDateTime]="plannedShiftEndDateTime"
        [accurateShiftStartDateTime]="shiftStartDetail.date"
        [accurateShiftEndDateTime]="shiftEndDetail.date"
        [shiftStartTimeDifference]="shiftStartDetail.timeDifference"
        [shiftEndTimeDifference]="shiftEndDetail.timeDifference"
        [shiftStartTimeType]="shiftStartDetail.type"
        [shiftEndTimeType]="shiftEndDetail.type"
        [plannedStartLocation]="plannedStartLocation"
        [plannedEndLocation]="plannedEndLocation"
        [reportedStartLocation]="reportedStartLocation"
        [reportedEndLocation]="reportedEndLocation"
        [displayTooltip]="!!isTooltipVisible"
      >
        <ng-container
          *ngTemplateOutlet="lightWeightAssignmentShiftCard"
        ></ng-container>
      </wilson-shift-validation-tooltip-wrapper>
    </ng-template>
  } @placeholder {
    <div>
      <ng-container
        *ngTemplateOutlet="
          shiftCardWrapper;
          context: {
            outletTemplate: lightWeightAssignmentShiftCard,
          }
        "
      >
      </ng-container>
    </div>
  }

  <ng-template #shiftCardWrapper let-outletTemplate="outletTemplate">
    @let presenceBorderColor = shiftId | shiftPresenceBorderColor | async;

    <div
      #shiftPreviewCard
      class="shift"
      [class.modified]="isShiftModified"
      [class.group-item]="
        !isShiftSelected &&
        groupItemsSelectionHelperService.groupedShiftIds().has(shiftId)
      "
      [ngClass]="{
        'd-none': !isShiftVisible,
        filtered: isFiltered || isDragging,
        'is-not-draggable': isShiftDraggableFeatureFlag && !isShiftDraggable,
        highlighted: isHighlighted,
        selected: isShiftSelected,
      }"
      [style.width.px]="calculatedShiftWidth"
      [class]="
        'timeline-shift-accent-border' +
        ' ' +
        'timeline-shift-type--' +
        shift.shiftCategoryId +
        ' ' +
        'timeline-shift-project--' +
        hasProjectReadPermission +
        '--' +
        project?.status
      "
      [ngStyle]="
        {
          shiftCategoryId: shift.shiftCategoryId,
          shiftColorOption: shiftColorOption,
          label: label,
          project: project,
          hasProjectReadPermission: hasProjectReadPermission,
          presenceBorderColor: presenceBorderColor,
        } | shiftCardColorStyle
      "
      [draggable]="isShiftDraggableFeatureFlag && isShiftDraggable"
      (click)="isSelectionEnabled && checkShiftKeyOnClick($event, undoTemplate)"
    >
      <div [style.max-height.px]="MAX_CELL_VIEW_UNASSIGNED_SHIFT_HEIGHT">
        <ng-container *ngTemplateOutlet="outletTemplate"></ng-container>
      </div>
    </div>
  </ng-template>

  <ng-template #lightWeightAssignmentShiftCard>
    <ng-container
      *ngTemplateOutlet="
        deferredUnassignedShiftCardCellViewHelperService.getPreviewTemplateContent();
        context: {
          shift: shift,
          showShiftValidation: showShiftValidation,
          isLoadingValidations: $any(isLoadingValidations),
          hasShiftBeenValidated: $any(hasShiftBeenValidated),
          isShiftValid: $any(isShiftValid),
          isLoadingValidationsError: $any(isLoadingValidationsError),
          loadIconsImmediately: true,
        }
      "
    ></ng-container>
  </ng-template>

  <ng-template #undoTemplate>
    <wilson-nz-message-timer-line [duration]="MESSAGE_DURATION">
      <wilson-message-with-undo-option></wilson-message-with-undo-option>
    </wilson-nz-message-timer-line>
  </ng-template>
}
